__turbopack_context__.v({
  "bottom": "technology-module__yBOhza__bottom",
  "bottomText": "technology-module__yBOhza__bottomText",
  "card": "technology-module__yBOhza__card",
  "cardLeft": "technology-module__yBOhza__cardLeft",
  "depth": "technology-module__yBOhza__depth",
  "depthActive": "technology-module__yBOhza__depthActive",
  "depthGroup": "technology-module__yBOhza__depthGroup",
  "depthIcon": "technology-module__yBOhza__depthIcon",
  "depthText": "technology-module__yBOhza__depthText",
  "fadeIn": "technology-module__yBOhza__fadeIn",
  "insetIn": "technology-module__yBOhza__insetIn",
  "lead": "technology-module__yBOhza__lead",
  "leadText": "technology-module__yBOhza__leadText",
  "pulse": "technology-module__yBOhza__pulse",
  "research": "technology-module__yBOhza__research",
  "root": "technology-module__yBOhza__root",
  "sonar": "technology-module__yBOhza__sonar",
});
